import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import {
  useArea,
  useCategory,
  useContractorPersonDropdown,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import { LOGGED_IN_USER_SITE_ID } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { UserService } from "app/_services/UserService/UserService";
import { getContractor } from "app/_services/Contractor/ContractorService";
import { medicalDueFilterFields, medicalFilterFields } from "../Constant";
import { TRAINEE_TYPE } from "../../TrainingManagement/CONSTANTS";

export default function MedicalDueFilters({ form, onChange, onReset, setForm }) {
  const [employees, employeesOption] = useEmployeeDropdown();
  const [contractorPersons, contractorPersonsOption] = useContractorPersonDropdown();
  const [category, categoryOption] = useCategory("filter[source]=training");

  const [nameList, setNameList] = useState([]);
  const [idList, setIdList] = useState([]);

  useEffect(() => {
    const employeeNameList = employees.map((d) => ({
      label: `${d.firstName} ${d.lastName}`,
      value: `${d.firstName} ${d.lastName}`,
    }));
    const employeeIdList = employees.map((d) => ({
      label: d.employeeId,
      value: d.employeeId,
    }));
    const contractorPersonsIdList = contractorPersons.map((d) => ({
      label: d.srNo,
      value: d.srNo,
    }));
    setNameList(
      form?.medicalAssigneeTypeView === TRAINEE_TYPE.employee
        ? employeeNameList
        : form?.medicalAssigneeTypeView === TRAINEE_TYPE.contractorPerson
        ? contractorPersonsOption?.map((d) => ({ ...d, value: d.label }))
        : [
            ...employeeNameList,
            ...contractorPersonsOption?.map((d) => ({ ...d, value: d.label })),
          ]
    );

    setIdList(
      form?.medicalAssigneeTypeView === TRAINEE_TYPE.employee
        ? employeeIdList
        : form?.medicalAssigneeTypeView === TRAINEE_TYPE.contractorPerson
        ? contractorPersonsIdList
        : [...employeeIdList, ...contractorPersonsIdList]
    );
  }, [
    contractorPersons,
    contractorPersonsOption,
    employees,
    form?.medicalAssigneeTypeView,
  ]);

  const fields = useMemo(
    () =>
      medicalDueFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "assigneeName":
            field.options = nameList;
            break;
          case "assigneeID":
            field.options = idList;
            break;
          case "categoryId":
            field.options = categoryOption;
            break;
          default:
            break;
        }

        return field;
      }),
    [nameList, idList, categoryOption]
  );

  return (
    <div className="pb-4">
      <FilterForm fields={fields} form={form} onChange={onChange} onReset={onReset} />
    </div>
  );
}
